import { createFileRoute } from "@tanstack/react-router";
import { SignIn } from "@/components/auth/signin";
import { validateAuthSearch } from "@/lib/auth";

export const Route = createFileRoute("/signin")({
  validateSearch: validateAuthSearch,
  component: SignInPage,
});

function SignInPage() {
  const { return_to } = Route.useSearch();
  return <SignIn mode="signin" returnTo={return_to} />;
}
